let moduleType = (value) => {
    let text = ''
    switch (value) {
        case 'route':
            text = '跟团游'
            break
        case 'park':
            text = '景区'
            break
        case 'hotel':
            text = '酒店'
            break
        case 'theater_ticket':
            text = '剧院'
            break 
        case 'eatery':
            text = '餐饮'
            break
        case 'mdse': 
            text = '商品'
            break
    }
    return text
}
export {
    moduleType
}


// WEBPACK FOOTER //
// ./src/filters/index.js